<template>
    <div class="page-wrapper">
        <h3 class="tit">EPIVG数据大屏</h3>
        <div class="top-btns">
            <el-button class="r-btn" type="primary" icon="el-icon-edit" size="medium" @click="editHandle" :disabled="!uneditable">编辑表单</el-button>
            <br>
            <el-button class="r-btn" type="success" icon="el-icon-link" size="medium" @click="linkToDataV">查看大屏</el-button>
            <br>
            <el-button class="r-btn" type="warning" icon="el-icon-circle-check" size="medium" @click="takeEffectAtOnce">立即生效</el-button>
            <br>
            <el-button class="r-btn" type="info" icon="el-icon-top" size="medium" @click="toPageTop">回到顶部</el-button>
        </div>
        <div class="datav-form-wrapper">
			<el-form class="c-form" :model="editForm" ref="editForm" label-position="top">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item class="c-form-item" label="总注册用户数量">
							<p class="info">
							    总注册用户数量 =衣加加用户总数+云和用户总数+附加值
							</p>
							<el-form-item class="c-form-item-inner" label="附加值（整数）" prop="totalUserRegisterNumberSetting"       
								:rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
							>
							
							    <el-input class="shortInput"
							        @blur="editForm.totalUserRegisterNumberSetting = switchToInt(editForm.totalUserRegisterNumberSetting, 'signed')"
							        v-model="editForm.totalUserRegisterNumberSetting"
							        placeholder="请输入"
							        :disabled="uneditable"
							    ></el-input>
							</el-form-item>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item class="c-form-item" label="月活数量">
							<p class="info">
							    月活数量 =衣加加月活+合作商数据+附加值
							</p>
							<el-form-item class="c-form-item-inner" label="附加值（整数）" prop="monthlyActiveNumberSetting"
								:rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
							>
							    <el-input class="shortInput"
							        @blur="editForm.monthlyActiveNumberSetting = switchToInt(editForm.monthlyActiveNumberSetting, 'signed')"
							        v-model="editForm.monthlyActiveNumberSetting"
							        placeholder="请输入"
							        :disabled="uneditable"
							    ></el-input>
							</el-form-item>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item class="c-form-item" label="本月新注册数量">
							<p class="info">
							    本月新注册数量 =衣加加本月新注册+合作商数据+附加值
							</p>
							<el-form-item class="c-form-item-inner" label="附加值（整数）" prop="newRegistrationsThisMonthNumberSetting"
								:rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
							>
							    <el-input class="shortInput"
							        @blur="editForm.newRegistrationsThisMonthNumberSetting = switchToInt(editForm.newRegistrationsThisMonthNumberSetting, 'signed')"
							        v-model="editForm.newRegistrationsThisMonthNumberSetting"
							        placeholder="请输入"
							        :disabled="uneditable"
							    ></el-input>
							</el-form-item>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item class="c-form-item" label="公司数量">
							<p class="info">
							    公司数量 =衣加加认证企业数量+附加值
							</p>
							<el-form-item class="c-form-item-inner" label="附加值（整数）" prop="companyNumberSetting"
								:rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
							>
							    <el-input class="shortInput"
							        @blur="editForm.companyNumberSetting = switchToInt(editForm.companyNumberSetting, 'signed')"
							        v-model="editForm.companyNumberSetting"
							        placeholder="请输入"
							        :disabled="uneditable"
							    ></el-input>
							</el-form-item>
						</el-form-item>
					</el-col>
				</el-row>
				
				
				
				
				
				
				
				<el-form-item class="c-form-item" label="全国落地项目数据">
				    <el-row :gutter="20">
				        <el-col :span="8">
				            <el-form-item class="c-form-item-inner" label="已落地项目（正整数）" prop="landedProjectNumberSetting"       
								:rules="[{ required: true, message: '请输入正整数', trigger: 'blur' }]"
				            >
				                <el-input
				                    @blur="editForm.landedProjectNumberSetting = switchToInt(editForm.landedProjectNumberSetting, 'unsigned')"
				                    v-model="editForm.landedProjectNumberSetting"
				                    placeholder="请输入"
				                    :disabled="uneditable"
				                ></el-input>
				            </el-form-item>
				        </el-col>
						<el-col :span="8">
						    <el-form-item class="c-form-item-inner" label="准落地项目（正整数）" prop="almostLandedProjectNumberSetting"       
								:rules="[{ required: true, message: '请输入正整数', trigger: 'blur' }]"
						    >
						        <el-input
						            @blur="editForm.almostLandedProjectNumberSetting = switchToInt(editForm.almostLandedProjectNumberSetting, 'unsigned')"
						            v-model="editForm.almostLandedProjectNumberSetting"
						            placeholder="请输入"
						            :disabled="uneditable"
						        ></el-input>
						    </el-form-item>
						</el-col>
						<el-col :span="8">
						    <el-form-item class="c-form-item-inner" label="推进中项目（正整数）" prop="progressProjectNumberSetting"       
								:rules="[{ required: true, message: '请输入正整数', trigger: 'blur' }]"
						    >
						        <el-input
						            @blur="editForm.progressProjectNumberSetting = switchToInt(editForm.progressProjectNumberSetting, 'unsigned')"
						            v-model="editForm.progressProjectNumberSetting"
						            placeholder="请输入"
						            :disabled="uneditable"
						        ></el-input>
						    </el-form-item>
						</el-col>
				        
				    </el-row>
				</el-form-item>
				<el-form-item class="c-form-item" label="订单数据-总交易额">
					<el-form-item class="c-form-item-inner" label="现货供应链交易额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="spotSupplyChainTransactionSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.spotSupplyChainTransactionSetting.fix"
								        @blur="editForm.spotSupplyChainTransactionSetting.fix = switchToInt(editForm.spotSupplyChainTransactionSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="spotSupplyChainTransactionSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.spotSupplyChainTransactionSetting.min = switchToInt(editForm.spotSupplyChainTransactionSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.spotSupplyChainTransactionSetting, 'min', 'max')"
										            v-model="editForm.spotSupplyChainTransactionSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="spotSupplyChainTransactionSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.spotSupplyChainTransactionSetting.max = switchToInt(editForm.spotSupplyChainTransactionSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.spotSupplyChainTransactionSetting, 'min', 'max')"
										            v-model="editForm.spotSupplyChainTransactionSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="期货产能交易额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="futuresCapacityTradingSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.futuresCapacityTradingSetting.fix"
								        @blur="editForm.futuresCapacityTradingSetting.fix = switchToInt(editForm.futuresCapacityTradingSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="futuresCapacityTradingSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.futuresCapacityTradingSetting.min = switchToInt(editForm.futuresCapacityTradingSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.futuresCapacityTradingSetting, 'min', 'max')"
										            v-model="editForm.futuresCapacityTradingSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="futuresCapacityTradingSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.futuresCapacityTradingSetting.max = switchToInt(editForm.futuresCapacityTradingSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.futuresCapacityTradingSetting, 'min', 'max')"
										            v-model="editForm.futuresCapacityTradingSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="设计创新服务交易额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="designInnovationServiceTransactionSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.designInnovationServiceTransactionSetting.fix"
								        @blur="editForm.designInnovationServiceTransactionSetting.fix = switchToInt(editForm.designInnovationServiceTransactionSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="designInnovationServiceTransactionSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.designInnovationServiceTransactionSetting.min = switchToInt(editForm.designInnovationServiceTransactionSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.designInnovationServiceTransactionSetting, 'min', 'max')"
										            v-model="editForm.designInnovationServiceTransactionSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="designInnovationServiceTransactionSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.designInnovationServiceTransactionSetting.max = switchToInt(editForm.designInnovationServiceTransactionSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.designInnovationServiceTransactionSetting, 'min', 'max')"
										            v-model="editForm.designInnovationServiceTransactionSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="培训服务交易额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="trainingServiceTransactionSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.trainingServiceTransactionSetting.fix"
								        @blur="editForm.trainingServiceTransactionSetting.fix = switchToInt(editForm.trainingServiceTransactionSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="trainingServiceTransactionSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.trainingServiceTransactionSetting.min = switchToInt(editForm.trainingServiceTransactionSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.trainingServiceTransactionSetting, 'min', 'max')"
										            v-model="editForm.trainingServiceTransactionSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="trainingServiceTransactionSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.trainingServiceTransactionSetting.max = switchToInt(editForm.trainingServiceTransactionSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.trainingServiceTransactionSetting, 'min', 'max')"
										            v-model="editForm.trainingServiceTransactionSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="供应链金融交易额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="supplyChainFinancialTransactionSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.supplyChainFinancialTransactionSetting.fix"
								        @blur="editForm.supplyChainFinancialTransactionSetting.fix = switchToInt(editForm.supplyChainFinancialTransactionSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="supplyChainFinancialTransactionSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.supplyChainFinancialTransactionSetting.min = switchToInt(editForm.supplyChainFinancialTransactionSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.supplyChainFinancialTransactionSetting, 'min', 'max')"
										            v-model="editForm.supplyChainFinancialTransactionSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="supplyChainFinancialTransactionSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.supplyChainFinancialTransactionSetting.max = switchToInt(editForm.supplyChainFinancialTransactionSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.supplyChainFinancialTransactionSetting, 'min', 'max')"
										            v-model="editForm.supplyChainFinancialTransactionSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
				</el-form-item>
				<el-form-item class="c-form-item" label="产业集群类（已落地项目）">
					<el-form-item class="c-form-item-inner" label="高阳数据-项目注册用户">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="gaoYangRegisterNumberSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.gaoYangRegisterNumberSetting.fix"
								        @blur="editForm.gaoYangRegisterNumberSetting.fix = switchToInt(editForm.gaoYangRegisterNumberSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangRegisterNumberSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangRegisterNumberSetting.min = switchToInt(editForm.gaoYangRegisterNumberSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangRegisterNumberSetting, 'min', 'max')"
										            v-model="editForm.gaoYangRegisterNumberSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangRegisterNumberSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangRegisterNumberSetting.max = switchToInt(editForm.gaoYangRegisterNumberSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangRegisterNumberSetting, 'min', 'max')"
										            v-model="editForm.gaoYangRegisterNumberSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
					<el-form-item class="c-form-item-inner" label="高阳数据-订单交易总额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="gaoYangTransactionAmountSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.gaoYangTransactionAmountSetting.fix"
								        @blur="editForm.gaoYangTransactionAmountSetting.fix = switchToInt(editForm.gaoYangTransactionAmountSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangTransactionAmountSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangTransactionAmountSetting.min = switchToInt(editForm.gaoYangTransactionAmountSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.gaoYangTransactionAmountSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangTransactionAmountSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangTransactionAmountSetting.max = switchToInt(editForm.gaoYangTransactionAmountSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.gaoYangTransactionAmountSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
					<!-- <el-form-item class="c-form-item-inner" label="临平数据-项目注册用户">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="linping_yangmuzhuceyonghu.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.linping_yangmuzhuceyonghu.fix"
								        @blur="editForm.linping_yangmuzhuceyonghu.fix = switchToInt(editForm.linping_yangmuzhuceyonghu.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="linping_yangmuzhuceyonghu.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.linping_yangmuzhuceyonghu.min = switchToInt(editForm.linping_yangmuzhuceyonghu.min, 'unsigned');
													switchObjMaxAndMin(editForm.linping_yangmuzhuceyonghu, 'min', 'max')"
										            v-model="editForm.linping_yangmuzhuceyonghu.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="linping_yangmuzhuceyonghu.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.linping_yangmuzhuceyonghu.max = switchToInt(editForm.linping_yangmuzhuceyonghu.max, 'unsigned');
													switchObjMaxAndMin(editForm.linping_yangmuzhuceyonghu, 'min', 'max')"
										            v-model="editForm.linping_yangmuzhuceyonghu.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item> -->
					<el-form-item class="c-form-item-inner" label="临平数据-订单交易总额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="linPingTransactionAmountSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.linPingTransactionAmountSetting.fix"
								        @blur="editForm.linPingTransactionAmountSetting.fix = switchToInt(editForm.linPingTransactionAmountSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="linPingTransactionAmountSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.linPingTransactionAmountSetting.min = switchToInt(editForm.linPingTransactionAmountSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.linPingTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.linPingTransactionAmountSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="linPingTransactionAmountSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.linPingTransactionAmountSetting.max = switchToInt(editForm.linPingTransactionAmountSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.linPingTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.linPingTransactionAmountSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
					<el-form-item class="c-form-item-inner" label="莆田数据-项目注册用户">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="puTianRegisterNumberSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.puTianRegisterNumberSetting.fix"
								        @blur="editForm.puTianRegisterNumberSetting.fix = switchToInt(editForm.puTianRegisterNumberSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="puTianRegisterNumberSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianRegisterNumberSetting.min = switchToInt(editForm.puTianRegisterNumberSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.puTianRegisterNumberSetting, 'min', 'max')"
										            v-model="editForm.puTianRegisterNumberSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="puTianRegisterNumberSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianRegisterNumberSetting.max = switchToInt(editForm.puTianRegisterNumberSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.puTianRegisterNumberSetting, 'min', 'max')"
										            v-model="editForm.puTianRegisterNumberSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="莆田数据-订单交易总额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="puTianTransactionAmountSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.puTianTransactionAmountSetting.fix"
								        @blur="editForm.puTianTransactionAmountSetting.fix = switchToInt(editForm.puTianTransactionAmountSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="puTianTransactionAmountSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianTransactionAmountSetting.min = switchToInt(editForm.puTianTransactionAmountSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.puTianTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.puTianTransactionAmountSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="puTianTransactionAmountSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianTransactionAmountSetting.max = switchToInt(editForm.puTianTransactionAmountSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.puTianTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.puTianTransactionAmountSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
					<el-form-item class="c-form-item-inner" label="云和数据-项目注册用户">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="yunHeRegisterNumberSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.yunHeRegisterNumberSetting.fix"
								        @blur="editForm.yunHeRegisterNumberSetting.fix = switchToInt(editForm.yunHeRegisterNumberSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeRegisterNumberSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeRegisterNumberSetting.min = switchToInt(editForm.yunHeRegisterNumberSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeRegisterNumberSetting, 'min', 'max')"
										            v-model="editForm.yunHeRegisterNumberSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeRegisterNumberSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeRegisterNumberSetting.max = switchToInt(editForm.yunHeRegisterNumberSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeRegisterNumberSetting, 'min', 'max')"
										            v-model="editForm.yunHeRegisterNumberSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="云和数据-订单交易总额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="yunHeTransactionAmountSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.yunHeTransactionAmountSetting.fix"
								        @blur="editForm.yunHeTransactionAmountSetting.fix = switchToInt(editForm.yunHeTransactionAmountSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeTransactionAmountSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeTransactionAmountSetting.min = switchToInt(editForm.yunHeTransactionAmountSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.yunHeTransactionAmountSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeTransactionAmountSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeTransactionAmountSetting.max = switchToInt(editForm.yunHeTransactionAmountSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.yunHeTransactionAmountSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
				</el-form-item>
				<el-form-item class="c-form-item" label="走势变化趋势图">
					<el-form-item class="c-form-item-inner" label="高阳-供应链交易提升百分比(高阳地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.gaoYangSupplyChainTransactionPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'gaoYangSupplyChainTransactionPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'gaoYangSupplyChainTransactionPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
						                    <template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.gaoYangSupplyChainTransactionPercent.length === 1}" 
						                :title="editForm.gaoYangSupplyChainTransactionPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('gaoYangSupplyChainTransactionPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('gaoYangSupplyChainTransactionPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="高阳-产能交易提升百分比(高阳地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.gaoYangCapacityTradingPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'gaoYangCapacityTradingPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'gaoYangCapacityTradingPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.gaoYangCapacityTradingPercent.length === 1}" 
						                :title="editForm.gaoYangCapacityTradingPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('gaoYangCapacityTradingPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('gaoYangCapacityTradingPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="高阳-人才服务提升百分比(高阳地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.gaoYangTalentServicePercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'gaoYangTalentServicePercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'gaoYangTalentServicePercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.gaoYangTalentServicePercent.length === 1}" 
						                :title="editForm.gaoYangTalentServicePercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('gaoYangTalentServicePercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('gaoYangTalentServicePercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					
					<el-form-item class="c-form-item-inner" label="临平-供应链交易提升百分比(临平地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.linPingSupplyChainTransactionPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'linPingSupplyChainTransactionPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'linPingSupplyChainTransactionPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.linPingSupplyChainTransactionPercent.length === 1}" 
						                :title="editForm.linPingSupplyChainTransactionPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('linPingSupplyChainTransactionPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('linPingSupplyChainTransactionPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="临平-产能交易提升百分比(临平地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.linPingCapacityTradingPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'linPingCapacityTradingPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'linPingCapacityTradingPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.linPingCapacityTradingPercent.length === 1}" 
						                :title="editForm.linPingCapacityTradingPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('linPingCapacityTradingPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('linPingCapacityTradingPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="临平-人才服务提升百分比(临平地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.linPingTalentServicePercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'linPingTalentServicePercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'linPingTalentServicePercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.linPingTalentServicePercent.length === 1}" 
						                :title="editForm.linPingTalentServicePercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('linPingTalentServicePercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('linPingTalentServicePercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					
					
					<el-form-item class="c-form-item-inner" label="莆田-供应链交易提升百分比(莆田地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.puTianSupplyChainTransactionPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'puTianSupplyChainTransactionPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'puTianSupplyChainTransactionPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.puTianSupplyChainTransactionPercent.length === 1}" 
						                :title="editForm.puTianSupplyChainTransactionPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('puTianSupplyChainTransactionPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('puTianSupplyChainTransactionPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="莆田-产能交易提升百分比(莆田地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.puTianCapacityTradingPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'puTianCapacityTradingPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'puTianCapacityTradingPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.puTianCapacityTradingPercent.length === 1}" 
						                :title="editForm.puTianCapacityTradingPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('puTianCapacityTradingPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('puTianCapacityTradingPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="莆田-人才服务提升百分比(莆田地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.puTianTalentServicePercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'puTianTalentServicePercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'puTianTalentServicePercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.puTianTalentServicePercent.length === 1}" 
						                :title="editForm.puTianTalentServicePercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('puTianTalentServicePercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('puTianTalentServicePercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					
					
					<el-form-item class="c-form-item-inner" label="云和-供应链交易提升百分比(云和地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.yunHeSupplyChainTransactionPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'yunHeSupplyChainTransactionPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'yunHeSupplyChainTransactionPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.yunHeSupplyChainTransactionPercent.length === 1}" 
						                :title="editForm.yunHeSupplyChainTransactionPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('yunHeSupplyChainTransactionPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('yunHeSupplyChainTransactionPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="云和-产能交易提升百分比(云和地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.yunHeCapacityTradingPercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'yunHeCapacityTradingPercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'yunHeCapacityTradingPercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.yunHeCapacityTradingPercent.length === 1}" 
						                :title="editForm.yunHeCapacityTradingPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('yunHeCapacityTradingPercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('yunHeCapacityTradingPercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="云和-人才服务提升百分比(云和地区年份保持一致)">
						<div class="c-row-wrap" v-for="(item, index) in editForm.yunHeTalentServicePercent" :key="item.key">
						    <el-row :gutter="20">
						        <el-col :span="1">
						            <span class="c-sort-num">{{index + 1}}</span> 
						        </el-col>
						        <el-col :span="9">
						            <el-form-item class="c-form-item-inner"
						                :prop="'yunHeTalentServicePercent.' + index + '.year'"
						                :rules="[
						                    { required: true, message: '请输入整数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.year" :disabled="uneditable"  
											@blur="item.year = switchToInt(item.year, 'unsigned')"
										>
						                    <template slot="prepend">年份</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="8">
						            <el-form-item class="c-form-item-inner"
						                :prop="'yunHeTalentServicePercent.' + index + '.value'"
						                :rules="[
						                    { required: true, message: '请输入数值，可为小数', trigger: 'blur' },
						                ]"
						            >
						                <el-input placeholder="请输入" v-model="item.value" :disabled="uneditable"
						                    @blur="item.value = switchToFloat(item.value, 'unsigned')"
						                >
						                    <template slot="prepend">年增长比率</template>
											<template slot="append">%</template>
						                </el-input>
						            </el-form-item>
						        </el-col>
						        <el-col :span="2" v-if="!uneditable">
						            <i class="el-icon-remove c-remove" 
						                :class="{'disabled': editForm.yunHeTalentServicePercent.length === 1}" 
						                :title="editForm.yunHeTalentServicePercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
						                @click="removeLine('yunHeTalentServicePercent', index)"
						            ></i>
						            <i class="el-icon-circle-plus c-add" title="添加一行"
						                @click="addLine('yunHeTalentServicePercent', index)"
						            ></i>
						        </el-col>
						    </el-row>
						</div>
					</el-form-item>
					
				</el-form-item>
				
				<el-form-item class="c-form-item" label="产业联动效果图-地区资源链接数据">
					
					<el-form-item class="c-form-item-inner" label="杭州-高阳-供应链交易合作金额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="gaoYangSupplyChainTransactionAmountSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.gaoYangSupplyChainTransactionAmountSetting.fix"
								        @blur="editForm.gaoYangSupplyChainTransactionAmountSetting.fix = switchToInt(editForm.gaoYangSupplyChainTransactionAmountSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangSupplyChainTransactionAmountSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangSupplyChainTransactionAmountSetting.min = switchToInt(editForm.gaoYangSupplyChainTransactionAmountSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangSupplyChainTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.gaoYangSupplyChainTransactionAmountSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangSupplyChainTransactionAmountSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangSupplyChainTransactionAmountSetting.max = switchToInt(editForm.gaoYangSupplyChainTransactionAmountSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangSupplyChainTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.gaoYangSupplyChainTransactionAmountSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="杭州-高阳-品牌建设合作项目数量" prop="gaoYangCooperativeProjectNumber"
						:rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
					>
					    <el-input class="shortInput"
					        @blur="editForm.gaoYangCooperativeProjectNumber = switchToInt(editForm.gaoYangCooperativeProjectNumber, 'unsigned')"
					        v-model="editForm.gaoYangCooperativeProjectNumber"
					        placeholder="请输入"
					        :disabled="uneditable"
					    ></el-input>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="杭州-高阳-产能订单下单数">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="gaoYangCapacityOrderNumberSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.gaoYangCapacityOrderNumberSetting.fix"
								        @blur="editForm.gaoYangCapacityOrderNumberSetting.fix = switchToInt(editForm.gaoYangCapacityOrderNumberSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangCapacityOrderNumberSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangCapacityOrderNumberSetting.min = switchToInt(editForm.gaoYangCapacityOrderNumberSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangCapacityOrderNumberSetting, 'min', 'max')"
										            v-model="editForm.gaoYangCapacityOrderNumberSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="gaoYangCapacityOrderNumberSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.gaoYangCapacityOrderNumberSetting.max = switchToInt(editForm.gaoYangCapacityOrderNumberSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.gaoYangCapacityOrderNumberSetting, 'min', 'max')"
										            v-model="editForm.gaoYangCapacityOrderNumberSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
					
					<el-form-item class="c-form-item-inner" label="杭州-云和-供应链交易合作金额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="yunHeSupplyChainTransactionAmountSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.yunHeSupplyChainTransactionAmountSetting.fix"
								        @blur="editForm.yunHeSupplyChainTransactionAmountSetting.fix = switchToInt(editForm.yunHeSupplyChainTransactionAmountSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeSupplyChainTransactionAmountSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeSupplyChainTransactionAmountSetting.min = switchToInt(editForm.yunHeSupplyChainTransactionAmountSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeSupplyChainTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.yunHeSupplyChainTransactionAmountSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeSupplyChainTransactionAmountSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeSupplyChainTransactionAmountSetting.max = switchToInt(editForm.yunHeSupplyChainTransactionAmountSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeSupplyChainTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.yunHeSupplyChainTransactionAmountSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="杭州-云和-品牌建设合作项目数量" prop="yunHeCooperativeProjectNumber"
						:rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
					>
					    <el-input class="shortInput"
					        @blur="editForm.yunHeCooperativeProjectNumber = switchToInt(editForm.yunHeCooperativeProjectNumber, 'unsigned')"
					        v-model="editForm.yunHeCooperativeProjectNumber"
					        placeholder="请输入"
					        :disabled="uneditable"
					    ></el-input>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="杭州-云和-产能订单下单数">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="yunHeCapacityOrderNumberSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.yunHeCapacityOrderNumberSetting.fix"
								        @blur="editForm.yunHeCapacityOrderNumberSetting.fix = switchToInt(editForm.yunHeCapacityOrderNumberSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeCapacityOrderNumberSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeCapacityOrderNumberSetting.min = switchToInt(editForm.yunHeCapacityOrderNumberSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeCapacityOrderNumberSetting, 'min', 'max')"
										            v-model="editForm.yunHeCapacityOrderNumberSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="yunHeCapacityOrderNumberSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.yunHeCapacityOrderNumberSetting.max = switchToInt(editForm.yunHeCapacityOrderNumberSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.yunHeCapacityOrderNumberSetting, 'min', 'max')"
										            v-model="editForm.yunHeCapacityOrderNumberSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
					<el-form-item class="c-form-item-inner" label="杭州-莆田-供应链交易合作金额">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="puTianSupplyChainTransactionAmountSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.puTianSupplyChainTransactionAmountSetting.fix"
								        @blur="editForm.puTianSupplyChainTransactionAmountSetting.fix = switchToInt(editForm.puTianSupplyChainTransactionAmountSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="puTianSupplyChainTransactionAmountSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianSupplyChainTransactionAmountSetting.min = switchToInt(editForm.puTianSupplyChainTransactionAmountSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.puTianSupplyChainTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.puTianSupplyChainTransactionAmountSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="puTianSupplyChainTransactionAmountSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianSupplyChainTransactionAmountSetting.max = switchToInt(editForm.puTianSupplyChainTransactionAmountSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.puTianSupplyChainTransactionAmountSetting, 'min', 'max')"
										            v-model="editForm.puTianSupplyChainTransactionAmountSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="杭州-莆田-品牌建设合作项目数量" prop="puTianCooperativeProjectNumber"
						:rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
					>
					    <el-input class="shortInput"
					        @blur="editForm.puTianCooperativeProjectNumber = switchToInt(editForm.puTianCooperativeProjectNumber, 'unsigned')"
					        v-model="editForm.puTianCooperativeProjectNumber"
					        placeholder="请输入"
					        :disabled="uneditable"
					    ></el-input>
					</el-form-item>
					<el-form-item class="c-form-item-inner" label="杭州-莆田-产能订单下单数">
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item class="c-form-item-inner" label="固定基数（整数）"  prop="puTianCapacityOrderNumberSetting.fix"
								    :rules="[{ required: true, message: '请输入整数', trigger: 'blur' }]"
								>
								    <el-input
								        v-model="editForm.puTianCapacityOrderNumberSetting.fix"
								        @blur="editForm.puTianCapacityOrderNumberSetting.fix = switchToInt(editForm.puTianCapacityOrderNumberSetting.fix)"
								        placeholder="请输入固定基数"
								        :disabled="uneditable"
								    ></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item class="c-form-item-inner" label="每日递增值范围（正整数）" required>
									<el-row :gutter="20">
										<el-col :span="6">
										    <el-form-item
										        prop="puTianCapacityOrderNumberSetting.min"
										        :rules="[
										            { required: true, message: '请输入递增范围最小值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianCapacityOrderNumberSetting.min = switchToInt(editForm.puTianCapacityOrderNumberSetting.min, 'unsigned');
													switchObjMaxAndMin(editForm.puTianCapacityOrderNumberSetting, 'min', 'max')"
										            v-model="editForm.puTianCapacityOrderNumberSetting.min"
										            placeholder="请输入递增范围最小值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
										<el-col class="gap-line" :span="1">-</el-col>
										<el-col :span="6">
										    <el-form-item
										        prop="puTianCapacityOrderNumberSetting.max"
										        :rules="[
										            { required: true, message: '请输入递增范围最大值', trigger: 'blur' }
										        ]"
										    >
										        <el-input
										            @blur="editForm.puTianCapacityOrderNumberSetting.max = switchToInt(editForm.puTianCapacityOrderNumberSetting.max, 'unsigned');
													switchObjMaxAndMin(editForm.puTianCapacityOrderNumberSetting, 'min', 'max')"
										            v-model="editForm.puTianCapacityOrderNumberSetting.max"
										            placeholder="请输入递增范围最大值"
										            :disabled="uneditable"
										        ></el-input>
										    </el-form-item>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form-item>
					
					
				</el-form-item>
				<el-form-item class="c-form-item" label="产业联动效果图-各地投资回报率">
				    <el-row :gutter="20">
				        <el-col :span="8">
				            <el-form-item class="c-form-item-inner" label="云和" prop="yunHeReturnRate"       
								:rules="[{ required: true, message: '请输入百分比,可为小数', trigger: 'blur' }]"
				            >
				                <el-input
				                    @blur="editForm.yunHeReturnRate = switchToFloat(editForm.yunHeReturnRate, 'unsigned')"
				                    v-model="editForm.yunHeReturnRate"
				                    placeholder="请输入"
				                    :disabled="uneditable"
				                >
									<template slot="append">%</template>
								</el-input>
				            </el-form-item>
				        </el-col>
						<el-col :span="8">
						    <el-form-item class="c-form-item-inner" label="高阳" prop="gaoYangReturnRate"       
								:rules="[{ required: true, message: '请输入百分比,可为小数', trigger: 'blur' }]"
						    >
						        <el-input
						            @blur="editForm.gaoYangReturnRate = switchToFloat(editForm.gaoYangReturnRate, 'unsigned')"
						            v-model="editForm.gaoYangReturnRate"
						            placeholder="请输入"
						            :disabled="uneditable"
						        >
									<template slot="append">%</template>
								</el-input>
						    </el-form-item>
						</el-col>
						<el-col :span="8">
						    <el-form-item class="c-form-item-inner" label="杭州" prop="hangZhouReturnRate"       
								:rules="[{ required: true, message: '请输入百分比,可为小数', trigger: 'blur' }]"
						    >
						        <el-input
						            @blur="editForm.hangZhouReturnRate = switchToFloat(editForm.hangZhouReturnRate, 'unsigned')"
						            v-model="editForm.hangZhouReturnRate"
						            placeholder="请输入"
						            :disabled="uneditable"
						        >
									<template slot="append">%</template>
								</el-input>
						    </el-form-item>
						</el-col>
				        
				    </el-row>
				</el-form-item>
				
				
				
			</el-form>
			
			<!-- button -->
            <div class="bottom-btns-wrap" v-if="!uneditable">
                <el-button class="btn-cancel" @click="cancelEdit">取消</el-button>
                <el-button class="btn-large" type="primary" @click="submitHandle">提交</el-button>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import {ajaxDatav} from '../../common/request_datav.js'
import {utils} from '../../common/common.js'
export default {
    data() {
        return {
            uneditable: true,
			editForm:{
				
				totalUserRegisterNumberSetting:'',
				monthlyActiveNumberSetting:'',
				newRegistrationsThisMonthNumberSetting:'',
				companyNumberSetting:'',
				//
				landedProjectNumberSetting:'',
				almostLandedProjectNumberSetting:'',
				progressProjectNumberSetting:'',
				// 
				
				spotSupplyChainTransactionSetting:{
					fix:'',
					min:'',
					max:''
				},
				futuresCapacityTradingSetting:{
					fix:'',
					min:'',
					max:''
				},
				designInnovationServiceTransactionSetting:{
					fix:'',
					min:'',
					max:''
				},
				trainingServiceTransactionSetting:{
					fix:'',
					min:'',
					max:''
				},
				supplyChainFinancialTransactionSetting:{
					fix:'',
					min:'',
					max:''
				},
				// 
				gaoYangRegisterNumberSetting:{
					fix:'',
					min:'',
					max:''
				},
				gaoYangTransactionAmountSetting:{
					fix:'',
					min:'',
					max:''
				},
				// linping_yangmuzhuceyonghu:{//废弃
				// 	fix:'',
				// 	min:'',
				// 	max:''
				// },
				linPingTransactionAmountSetting:{
					fix:'',
					min:'',
					max:''
				},
				puTianRegisterNumberSetting:{
					fix:'',
					min:'',
					max:''
				},
				puTianTransactionAmountSetting:{
					fix:'',
					min:'',
					max:''
				},
				yunHeRegisterNumberSetting:{
					fix:'',
					min:'',
					max:''
				},
				yunHeTransactionAmountSetting:{
					fix:'',
					min:'',
					max:''
				},
				// 
				
				gaoYangSupplyChainTransactionPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				gaoYangCapacityTradingPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				gaoYangTalentServicePercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				
				linPingSupplyChainTransactionPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				linPingCapacityTradingPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				linPingTalentServicePercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				
				puTianSupplyChainTransactionPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				puTianCapacityTradingPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				puTianTalentServicePercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				yunHeSupplyChainTransactionPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				yunHeCapacityTradingPercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				yunHeTalentServicePercent: [
				    {
				        key: 1,
				        year: '', // 
				        value: '' // 
				    }
				],
				gaoYangSupplyChainTransactionAmountSetting:{
					fix:'',
					min:'',
					max:''
				},
				gaoYangCooperativeProjectNumber:'',
				gaoYangCapacityOrderNumberSetting:{
					fix:'',
					min:'',
					max:''
				},
				
				yunHeSupplyChainTransactionAmountSetting:{
					fix:'',
					min:'',
					max:''
				},
				yunHeCooperativeProjectNumber:'',
				yunHeCapacityOrderNumberSetting:{
					fix:'',
					min:'',
					max:''
				},
				
				puTianSupplyChainTransactionAmountSetting:{
					fix:'',
					min:'',
					max:''
				},
				puTianCooperativeProjectNumber:'',
				puTianCapacityOrderNumberSetting:{
					fix:'',
					min:'',
					max:''
				},
				
				yunHeReturnRate:'',
				gaoYangReturnRate:'',
				hangZhouReturnRate:'',
				
			},
        }
    },
    created() {
        this.getData();
    },
    methods: {
        // 编辑操作
        editHandle() {
            this.uneditable = false
        },
        // 取消编辑
        cancelEdit() {
            this.$confirm('确认取消编辑吗?', '提示', {
                confirmButtonText: '取消编辑',
                cancelButtonText: '继续编辑',
                type: 'warning'
            }).then(() => {
                this.uneditable = true
                this.$refs['editForm'].clearValidate()
                this.getData();
            })
        },
        // 跳转外部链接
        linkToDataV() {
			var env=utils.getCurrentApi()
			let url=''
			if(env=='dev'){
				url='https://dv.dev.epivg.com'
			}else if(env=='test'){
				url='https://dv.test.epivg.com'
			}else{
				url='https://dv.epivg.com'
			}
			console.log(env)
            window.open(url)
        },
        // 立即生效
        takeEffectAtOnce() {
            this.$confirm('数据配置默认第二天零点生效，若需立即生效，可使用本功能。本功能将立即刷新数据到大屏，有可能造成当日数据前后不一致。请谨慎使用。', '提示', {
                confirmButtonText: '立即生效',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log('立即生效')
                ajaxDatav.post('/data-statistics/refreshByNumber', {
                    number: 6
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交成功，配置的数据会立即生效到大屏！');
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(e => {
                    console.error(e)
                })
            }).catch(err=> {
                console.log(err)
            })
        },
        // 回到顶部
        toPageTop() {
            document.querySelector('#mainBox').scrollTop = 0;
        },
        // 删除一行
        removeLine(key, index) {
            let length = this.editForm[key].length
            if (length <= 1) return
            this.editForm[key].splice(index, 1)
        },
        // 添加一行
        addLine(key, index) {
            let d = Date.now()
            let item
			item = {
			    key: d,
			    year: '',
			    value: ''
			}
            this.editForm[key].splice(index+1, 0, item)
        },
        // 转化为整数
        switchToInt(value, type) {
            let v = parseInt(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 转化为浮点数
        switchToFloat(value, type) {
            let v = parseFloat(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 获取数据
        getData() {
            ajaxDatav.get('/data-setting/getByNumber', {
                number: 6
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data && res.data.content) {
                        try {
                            let content = JSON.parse(res.data.content);
							console.log(content)
                            this.editForm = {
                                ...this.editForm,
                                ...content
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(e => {
                console.error(e);
            })
        },
		checkYearArr(){
			let result=true
			console.log(arguments)
			if(!arguments||arguments.length==0){
				result=false
			}else{
				var length=arguments[0].length
				for (var i=0;i<arguments.length;i++){
					if(arguments[i].length!=length){
						result=false
					}
				}
				let firstArr=arguments[0]
				for(var i=0;i<firstArr.length;i++){
					let year=firstArr[i].year
					for (var j=0;j<arguments.length;j++){
						console.log(arguments[j][i],'当前')
						if(!arguments[j][i]){
							console.log("当前这个不存在")
							result=false
						}else if(arguments[j][i].year!=year){
							console.log("当前这个不一致",'a'+arguments[j][i].year,year)
							result=false
						}
					}
				}
			}
			return result
		},
        // 提交表单
        submitHandle() {
            console.log(this.editForm);
            console.log(JSON.stringify(this.editForm));
			
			var gaoYangYearValid=this.checkYearArr(this.editForm.gaoYangSupplyChainTransactionPercent,this.editForm.gaoYangCapacityTradingPercent,this.editForm.gaoYangTalentServicePercent)
			if(!gaoYangYearValid){
				this.$message.error("高阳地区年份请保持一致")
				return false
			}
			var gaoYangYearValid=this.checkYearArr(this.editForm.linPingSupplyChainTransactionPercent,this.editForm.linPingCapacityTradingPercent,this.editForm.linPingTalentServicePercent)
			if(!gaoYangYearValid){
				this.$message.error("临平地区年份请保持一致")
				return false
			}
			var gaoYangYearValid=this.checkYearArr(this.editForm.puTianSupplyChainTransactionPercent,this.editForm.puTianCapacityTradingPercent,this.editForm.puTianTalentServicePercent)
			if(!gaoYangYearValid){
				this.$message.error("莆田地区年份请保持一致")
				return false
			}
			var gaoYangYearValid=this.checkYearArr(this.editForm.yunHeSupplyChainTransactionPercent,this.editForm.yunHeCapacityTradingPercent,this.editForm.yunHeTalentServicePercent)
			if(!gaoYangYearValid){
				this.$message.error("云和地区年份请保持一致")
				return false
			}
			
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在提交数据...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    ajaxDatav.post('/data-setting/save', {
                        content: JSON.stringify(this.editForm),
                        number: 6
                    }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.uneditable = true
                            this.getData();
                        } else {
                            this.$message.error(res.msg)
                        }
                    }).catch(e => {
                        console.error(e)
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    this.$message.error('校验不通过，请检查表单')
                }
            })
        },
        // 自定义校验规则
        // validateTotalOrderAmount(rule, value, callback) {
        //     if (this.editForm.totalOrderAmount.dayMin === '' || this.editForm.totalOrderAmount.dayMax === '') {
        //         callback();
        //     } else if (
        //         this.editForm.totalOrderAmount.dayMin > this.editForm.totalOrderAmount.dayMax) {
        //         callback(new Error('最小值不能大于最大值!'));
        //     } else {
        //         this.$refs.editForm.clearValidate('totalOrderAmount.dayMin');
        //         this.$refs.editForm.clearValidate('totalOrderAmount.dayMax');
        //     }
        // },
        // 自动切换对象中最大值和最小值
        switchObjMaxAndMin(obj, min='min', max='max') {
            if (obj[min] === '' || obj[max] === '') return
            if (obj[min] > obj[max]) {
                let middle = obj[min]
                obj[min] = obj[max]
                obj[max] = middle
            }
        },
        // 自动切换列表中最大值和最小值
        // switchMaxAndMin(list, index, min='min', max='max') {
        //     if (list[index][min] === '' || list[index][max] === '') return
        //     if (list[index][min] > list[index][max]) {
        //         let middle = list[index][min]
        //         list[index][min] = list[index][max]
        //         list[index][max] = middle
        //     }
        // }

    }
}
</script>

<style scoped lang="scss">

.page-wrapper {
	
	.datav-form-wrapper .el-form-item .c-form-item-inner{
		margin-bottom: 14px; 
	}
	
	.shortInput{width: 280px;}
	
    background: #fff;
    padding-bottom: 80px;
    min-height: 100px;
    .tit {
        margin: 0;
        padding: 24px;
        font-size: 20px;
        color: #111;
        font-weight: normal;
    }
    .top-btns {
        position: fixed;
        top: 40%;
        right: 32px;
        z-index: 100;
        .r-btn {
            margin-top: 6px;
        }
    } 
    .datav-form-wrapper {
        width: 900px;
        padding: 0 24px;
        .w {
            width: 400px;
        }
        .w2 {
            width: 200px;
        }
        .info {
            font-size: 13px;
            color: #888;
            line-height: 1.5;
        }
    }
    .c-row-wrap {
        padding: 8px 0;
    }
    .c-sort-num {
        margin-top: 12px;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #999;
        line-height: 20px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-radius: 50%;
    }
    .c-remove {
        margin-right: 4px;
        cursor: pointer;
        font-size: 16px;
        &.disabled {
            color: #ccc;
            cursor: no-drop;
        }
    }
    .c-add {
        font-size: 16px;
        cursor: pointer;
    }
    .bottom-btns-wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0 20px 0px;
        text-align: center;
        z-index: 1;
        background: #fff;
        box-shadow: 0 -2px 10px #ccc;
        .btn-large {
            padding: 14px 120px;
        }
        .btn-cancel {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/datav/epivg.vue